import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  MeetingTypeAvailabilityRequest,
  MeetingTypeAvailabilityResponse,
} from '../models/meeting.model';

/**
 * CRUD de franjas horarias permitidas por tipo de reunión (INC 35).
 * Rutas: /api/meeting-types/{typeId}/availability
 */
@Injectable({ providedIn: 'root' })
export class MeetingTypeAvailabilityApiService {
  private base = `${environment.apiUrl}api/meeting-types`;
  constructor(private http: HttpClient) {}

  list(
    typeId: number,
    businessId: number
  ): Observable<MeetingTypeAvailabilityResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingTypeAvailabilityResponse[]>(
      `${this.base}/${typeId}/availability`,
      { params }
    );
  }

  create(
    typeId: number,
    body: MeetingTypeAvailabilityRequest
  ): Observable<MeetingTypeAvailabilityResponse> {
    return this.http.post<MeetingTypeAvailabilityResponse>(
      `${this.base}/${typeId}/availability`,
      body
    );
  }

  update(
    typeId: number,
    id: number,
    body: MeetingTypeAvailabilityRequest
  ): Observable<MeetingTypeAvailabilityResponse> {
    return this.http.put<MeetingTypeAvailabilityResponse>(
      `${this.base}/${typeId}/availability/${id}`,
      body
    );
  }

  delete(typeId: number, id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(
      `${this.base}/${typeId}/availability/${id}`,
      { params }
    );
  }
}
